import React, { useState, useContext } from "react";
import { Card, Button, Collapsible, Icon, Stack, Text } from "@shopify/polaris";
import { CaretDownMinor, CaretUpMinor } from "@shopify/polaris-icons";
import { AppContext } from "../global/appContext";
import { useTranslation } from "react-i18next";
import moment from "moment";

export default function TrialCard(props) {
  const [open, setOpen] = useState(false);
  const appContext = useContext(AppContext);
  const { t } = useTranslation();

  if (!appContext.plan) return null;
  const { type, trial } = appContext.plan;
  if (type !== "Plan::Trial") return null;
  if (!trial) return null;

  const formattedEndDate = moment(trial.ends_on).format("MMMM Do");

  let title = t("settings.plan.trial.daysLeftInTrial", { days: trial.days_left });
  if (trial.days_used <= 1) title = t("settings.plan.trial.yourTrialJustStarted");
  if (trial.days_left == 1) title = t("settings.plan.trial.trialEndsTomorrow");
  if (trial.days_left == 0) title = t("settings.plan.trial.trialEndsAfterToday");

  let description = t("settings.plan.trial.continueAddingLocations", { date: formattedEndDate });
  if (trial.days_left == 0)
    description = t("settings.plan.trial.selectPlanToday");

  return (
    <div className={`trial-card ${open ? "open" : ""}`}>
      <Card>
        <div
          style={{ padding: "1rem", cursor: "pointer" }}
          onClick={() => setOpen(!open)}
        >
          <Stack
            alignment="center"
            spacing="tight"
            distribution="equalSpacing"
            wrap={false}
          >
            <Text variant="headingMd" as="h2">{title}</Text>
            <Icon
              source={open ? CaretDownMinor : CaretUpMinor}
              color="subdued"
              backdrop
            />
          </Stack>
        </div>
        <Collapsible
          open={open}
          transition={{ duration: "250ms", timingFunction: "ease-in-out" }}
          expandOnPrint
        >
          <div style={{ padding: "1rem", paddingTop: "0" }}>
            <div style={{ marginBottom: "1rem" }}>
              <p>{description}</p>
            </div>
            <Button primary fullWidth url="/settings/plan/edit">
              {t("settings.plan.trial.selectPlan")}
            </Button>
          </div>
        </Collapsible>
      </Card>
    </div>
  );
}
